import { ReactNode } from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'
import { RegisterLayout } from '@/components/layout/entry-layout'
import { RegisterEntryCard } from '@/components/register/register-entry-card'
import { useBreakpoint } from '@/hooks/use-breakpoint'
import { NextLayoutComponentType } from '@/types/next-layout-component-type'
import { ampli } from '@/utils/ampli'

const Register: NextLayoutComponentType = () => {
  const breakpoint = useBreakpoint()
  const isPC = breakpoint === 'PC'

  useMount(() => {
    ampli.viewSignupScreen({})
  })

  return (
    <Container $isPC={isPC}>
      <RegisterEntryCard />
    </Container>
  )
}

const Container = styled.div<{ $isPC: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${(props): string => (props.$isPC ? 'auto' : 'fit-content')};
`

Register.getLayout = (page): ReactNode => (
  <RegisterLayout>{page}</RegisterLayout>
)

export default Register
